module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', [_c('div', {
    staticClass: "background"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('v-ons-row', {
    staticClass: "map-detail-head"
  }, [_c('v-ons-col', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowDetail && _vm.isShowList),
      expression: "isShowDetail && isShowList"
    }],
    staticClass: "map-back-to-list",
    attrs: {
      "vertical-align": "center"
    }
  }, [_c('v-ons-button', {
    staticClass: "back-to-top",
    attrs: {
      "modifier": "light back"
    },
    on: {
      "click": _vm.backToList
    }
  }, [_vm._v("\n          一覧に戻る\n        ")])], 1), _vm._v(" "), _c('v-ons-col', {
    staticClass: "map-detail-close"
  }, [_c('img', {
    attrs: {
      "src": require("@/assets/images/close_button.svg")
    },
    on: {
      "click": _vm.clearDestinations
    }
  })])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": _vm.transitionName
    }
  }, [(_vm.isShowDetail) ? _c('destination-detail') : (_vm.isShowList) ? _c('destination-list') : _vm._e()], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e1b1466","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/map/destination/panel.vue
// module id = 645
// module chunks = 0